import { render, staticRenderFns } from "./certInfoManage.vue?vue&type=template&id=88c538f4&scoped=true"
import script from "./certInfoManage.vue?vue&type=script&lang=js"
export * from "./certInfoManage.vue?vue&type=script&lang=js"
import style0 from "./certInfoManage.vue?vue&type=style&index=0&id=88c538f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c538f4",
  null
  
)

export default component.exports